export const defaultWidgetNewAuthGateBaseUrl = 'https://widget-new.system123.ru/';
export const defaultWidgetNewMaterialAssignmentAuthGateBaseUrl =
  'https://material-assignment.system123.ru/';

function normalizeWidgetBaseUrl(baseUrl) {
  if (typeof baseUrl !== 'string') {
    return '';
  }

  const trimmedBaseUrl = baseUrl.trim();
  if (trimmedBaseUrl.length === 0) {
    return '';
  }

  try {
    return new URL(trimmedBaseUrl).toString();
  } catch {
    return '';
  }
}

function buildWidgetProjectUrlByPath({
  baseUrl,
  calculationGuid,
  companyId,
  projectGuid,
  projectPath,
}) {
  const normalizedBaseUrl = normalizeWidgetBaseUrl(baseUrl);
  if (normalizedBaseUrl === '') {
    return '';
  }

  if (typeof calculationGuid !== 'string' || calculationGuid.trim().length === 0) {
    return normalizedBaseUrl;
  }

  if (typeof projectGuid !== 'string' || projectGuid.trim().length === 0) {
    return normalizedBaseUrl;
  }

  const widgetUrl = new URL(`${projectPath}/${projectGuid}/${calculationGuid}`, normalizedBaseUrl);
  const parsedCompanyId = Number(companyId);
  if (Number.isInteger(parsedCompanyId) && parsedCompanyId > 0) {
    widgetUrl.searchParams.set('companyId', String(parsedCompanyId));
  }

  return widgetUrl.toString();
}

export function buildWidgetProjectUrl({
  baseUrl,
  calculationGuid,
  companyId,
  projectGuid,
}) {
  return buildWidgetProjectUrlByPath({
    baseUrl,
    calculationGuid,
    companyId,
    projectGuid,
    projectPath: '/v0/project',
  });
}

export function buildWidgetNewProjectAuthGateUrl({
  baseUrl,
  calculationGuid,
  companyId,
  projectGuid,
}) {
  return buildWidgetProjectUrlByPath({
    baseUrl,
    calculationGuid,
    companyId,
    projectGuid,
    projectPath: '/v0/auth-gate/project',
  });
}
